/* eslint-disable */
import {website_name} from '../../application'
import {cadex_website_name} from '../../application'
import {
    SET_GLOBAL_VARIABLE,
  } from '../mutation_types'

  const state = {
    home_text: website_name,
    cadex_home_text: cadex_website_name,
    judge_is_logged_in: false,
    judge_is_not_logged_in: false,
    version: "1.0"
  }

  const mutations = {
    //设置用户个人信息
    [SET_GLOBAL_VARIABLE] (state, data) {
      try {
        Object.keys(data).forEach(function(key){
            state[key] = data[key]
        })
      } catch (err) {
        console.log(err)
      }
    },
  }


  const actions = {
    [SET_GLOBAL_VARIABLE] ({ commit, state }, data) {
      //保存信息
      if (data !== undefined) {
        commit(SET_GLOBAL_VARIABLE, data)
      }
    }
  }

  export default {
    state,
    mutations,
    actions,
  }
